export default __webpack_public_path__ + "static/media/ic_actionbar_back.b24a7584.svg";